import Weather from "./weather.js";
import './index.css';

function App() {
  return (
    
    
     <div className="WeatherApp">
      <Weather defaultCity = "Glasgow" />
    </div>
  );
}

export default App;
